
import { useState } from 'react';

export const useFamilyDialogs = () => {
  const [isAddFamilyDialogOpen, setIsAddFamilyDialogOpen] = useState(false);
  const [isAddFamilyWithParentDialogOpen, setIsAddFamilyWithParentDialogOpen] = useState(false);

  console.log("🔥 useFamilyDialogs hook called", { isAddFamilyDialogOpen, isAddFamilyWithParentDialogOpen });

  return {
    isAddFamilyDialogOpen,
    setIsAddFamilyDialogOpen,
    isAddFamilyWithParentDialogOpen,
    setIsAddFamilyWithParentDialogOpen
  };
};
